import React, { useState } from "react";
import "./index.scss";
import { Box, Button, Typography, TextField } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  INTRANETHOSTNAME,
  REST_URLS,
} from "../../packages/common-utilities/utils/end-points";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();
  const { type } = useParams();

  const validateEmail = (email) => {
    if (!email) {
      return "Email is required";
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      return "Email is invalid";
    }
    return "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(validateEmail(value));
  };

  const forgotPasswordHandler = () => {
    let payload = {};
    if (email?.includes("@")) {
      payload["email"] = email;
    } else {
      payload["userId"] = email;
    }
    let url = REST_URLS.FORGOT_PASSWORD;

    invokeApi(HTTP_METHODS.POST, `${INTRANETHOSTNAME}${url}`, payload)
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("We have sent you an email to reset your password.");
          setEmail("");
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="forgot-pass-con">
      <div className="content-con">
        <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center" }}>
          Forgot Password?
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "gray", textAlign: "center", mt: 1 }}
        >
          No worries, we'll send you reset instruction.
        </Typography>
        <Box
          sx={{
            width: { md: "70%", xs: "100%", sm: "100%" },
          }}
        >
          <TextField
            fullWidth
            label="Email / User Id"
            type="email"
            value={email}
            onChange={handleEmailChange}
            // error={!!emailError}
            // helperText={emailError}
            size="small"
            margin="normal"
            placeholder="Enter your email / User Id"
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={forgotPasswordHandler}
            disabled={!email}
          >
            Reset Password
          </Button>
          <Button fullWidth sx={{ mt: 2 }} onClick={() => navigate("/")}>
            Back to Login
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ForgotPassword;
